<template>
  <nav class="navbar">
    <div class="logo-title" @click="navigateTo('/')">Appskeletons</div>
    <div v-show="navigationBarState === 0" class="account-actions">
      <div @click="navigateTo('sign-up')">Create Account</div>
      <button @click="navigateTo('login')">Sign in</button>
    </div>
    <ProfileDropdown v-show="navigationBarState === 1" class="profile-dropdown"/>
  </nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ProfileDropdown from "@/components/ProfileDropdown.vue";

export default {
  name: "NavigationBar",
  components: {
    ProfileDropdown
  },
  methods: {
    navigateTo(routeName) {
      this.$router.push(routeName);
    },
  },
  computed: {
    ...mapState(["navigationBarState"]),

  }
};
</script>

<style lang="scss">
$navbar-height: 60px;
.navbar {
  height: $navbar-height;
}

.profile-dropdown {
  float: right;
  position: fixed;
  top: 10px;
  right: 0;
  z-index: 200;
}

.logo-title {
  text-transform: uppercase;
  font-weight: 900;
  display: inline-block;
  position: fixed;
  top: 20px;
  left: 30px;
  cursor: pointer;
}

.account-actions {
  display: grid;
  position: fixed;
  right: 30px;
  top: 30px;
  grid-template-columns: repeat(2, auto);

  button, div {
    font-size: 0.8em;
  }

  button {
    height: 30px;
    width: 100px;
    padding: 0;
  }

  div {
    margin-right: 40px;
    margin-top: 5px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.3s;
  }

  div:hover {
    font-size: 0.9em;
  }
}

</style>
